import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/medium-m': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M71.5 142.3c0.6-5.9-1.7-11.8-6.1-15.8l-45.1-54.4v-8.1h140.2l108.4 237.7 95.3-237.7h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-0.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1h-189.7v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8v-219.8l-108.7 275.9h-14.7l-126.4-275.9v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8l50.8-61.7c5.4-5.6 7.9-13.5 6.5-21.2v-213.8z'
      }
    ]
  }
})
